import React from 'react'
import { map } from 'lodash'

import SocialIcons from '../../components/SocialIcons'

export default ({clinic}) => {
  if (!clinic || clinic.socialMedia.length === 0) return null

  return (
    <div className="min-h-64 bg-gradient-to-b from-sky-300 to-sky-400">
      <div className="max-w-6xl mx-auto px-4 py-16 min-h-64">
        <div className="flex justify-center content-center gap-8">
          <SocialIcons classes="w-16 h-16" clinic={clinic} />
        </div>
      </div>
    </div>
  )
}